export const ErrorsConfig = {
    serverError: "Something bad happened. Please try again later",    
    required: "Required",
    datepicker: {        
        earlyPickupDate: "Pickup Date can't later Delivery date",
        earlyDeliveryDate: "Delivery Date can't before Pickup date",
        latePickupDate: "Pickup Date can't later Delivery date",
        lateDeliveryDate: "Delivery Date can't before Pickup date",
        matDatepickerMin: "Previous date is not allowed",
        matDatepickerMax: "Pickup Date can't later Delivery date"
    },
    input: {
        specialCharacter: "Special character not allowed",
        number: "Only whole positive number allowed",
        decimal: "Only positive number allowed"
    },
    autocomplete: {
        notFound: "No record found for text entered",
        selectFromList: "Please select from list"
    }    
}